import { z } from 'zod';

export const AccountBillingPageQueryDto = z
  .object({
    limit: z.coerce.number().int().min(1).max(100).optional(),
    offset: z.coerce.number().int().min(0).optional(),
  })
  .strict();

export type ApiAccountBillingPageQueryDto = z.infer<
  typeof AccountBillingPageQueryDto
>;
